import AlreadyExistsView from "components/ContactForm/forms/views/AlreadyExistsView"
import ProcessingView from "components/ContactForm/forms/views/ProcessingView"
import FormWrapper, { FormResponse } from "components/ContactForm/FormWrapper"
import { useGlobalContext } from "components/layout/GlobalContext"
import Button from "components/shared/Button"
import Checkbox from "components/shared/Checkbox"
import CountryCodeInput, {
  countryCodes,
} from "components/shared/inputs/CountryCodeInput"
import { checkAudioExists, uploadAudio } from "lib/api"
import { getPath } from "lib/helpers"
import Link from "next/link"
import { useRouter } from "next/router"
import { Trans, useTranslation } from "next-i18next"
import { useEffect, useState } from "react"
import { Form } from "schemas"

import CustomFields, { FileInput, useFileSchema } from "./CustomFields"

const s = {}

type Props = {
  fullWidth?: boolean
  customForm?: Form
}

const nvSecret = process.env.NEXT_PUBLIC_NV_SECRET

function AnalyzeVoiceForm({ fullWidth, customForm }: Props) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<FormResponse>()
  const [existsData, setExistsData] = useState<FormResponse>()

  const { t } = useTranslation()
  const { query, locale, push, isReady } = useRouter()
  const { fpHash } = useGlobalContext()
  const fileSchema = useFileSchema()

  useEffect(() => {
    if (!isReady) return
    if (nvSecret && query.no_validate === nvSecret) return

    const checkExists = async () => {
      if (!fpHash) return

      const result = await checkAudioExists(fpHash)
      if (result.error) {
        setExistsData(result)
      }
    }

    checkExists()
  }, [fpHash, isReady, query.no_validate])

  const handleSubmit = async event => {
    event.preventDefault()

    const files = event.target.analyzeVoice.files
    const parsedFile = await fileSchema.safeParseAsync(files)
    if (!parsedFile.success) {
      setData({
        error: true,
        message: parsedFile.error?.issues?.[0]?.message,
      })
      setLoading(false)
      return
    }

    setData(null)
    setLoading(true)

    let fileUpload: Awaited<ReturnType<typeof uploadAudio>>
    try {
      fileUpload = await uploadAudio(files[0])
    } catch (e) {
      setData({
        error: true,
        message: `Error file upload: ${JSON.stringify(e)}`,
      })
      setLoading(false)
      return
    }

    console.log(fileUpload)

    // const { utm_source, utm_medium, utm_campaign } = query

    // const extraData = customForm
    //   ? customForm.fields?.reduce((acc, curr) => {
    //       if ("hubspotId" in curr)
    //         acc[curr.hubspotId] = event.target[curr.hubspotId].value
    //       return acc
    //     }, {})
    //   : {}

    // const countryCode = getFormCountryCode(event.target)

    // const data = {
    //   firstName: event.target.firstName.value,
    //   lastName: event.target.lastName.value,
    //   email: event.target.email.value,
    //   phone: `+${countryCode.phone}${event.target.phone.value}`,
    //   countryCode: countryCode.code,
    //   terms: event.target.terms.checked,
    //   analyzeVoice: {
    //     url: fileUpload.mediaUrl,
    //     duration: await getDuration(files),
    //   },
    //   form_id: customForm?.formId,
    //   fingerprint: fpHash,
    //   noValidate: query.no_validate,
    //   utm_source,
    //   utm_medium,
    //   utm_campaign,
    //   ...extraData,
    // }

    // const result = await createAudioLead(data)

    // setData(result)

    // setLoading(false)

    // if (result.error) {
    //   setLoading(false)
    // } else {
    //   event.target.reset()
    //   const id = result?.data?.id
    //   push({
    //     pathname: `/resumen-de-llamadas-y-sentiment-analysis-IA/${id}/resultado`,
    //   })
    // }
  }

  return (
    <FormWrapper
      className={fullWidth ? s.wide : s.form}
      onSubmit={handleSubmit}
      data={data}
      data-type="embeddedForm-analyze">
      <div className={s.fieldGroup}>
        <input
          className={s.input}
          name="firstName"
          placeholder={t("firstname")}
        />

        <input
          className={s.input}
          name="lastName"
          placeholder={t("lastname")}
        />
      </div>

      <input className={s.input} name="email" placeholder={t("email")} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "150px 1fr",
          gap: "1em",
        }}>
        <div className={s.selectWrap}>
          <CountryCodeInput className={s.select} />
        </div>

        <input className={s.input} name="phone" placeholder={t("phone")} />
      </div>

      <CustomFields fields={customForm?.fields} />

      <FileInput variant="primary-light" name="analyzeVoice" accept="audio/*">
        {t("uploadFile")}
      </FileInput>

      <Checkbox
        name="terms"
        label={
          <Trans
            i18nKey="termsLabel"
            components={{
              terms: <Link href={getPath("termsConditions", locale)} />,
              privacy: <Link href={getPath("privacyPolicy", locale)} />,
            }}
          />
        }
      />

      <Button type="submit">{customForm?.submitLabel || t("submit")}</Button>

      {loading && <ProcessingView />}
      {existsData && <AlreadyExistsView data={existsData.data} />}
    </FormWrapper>
  )
}

const getFormCountryCode = target => {
  const countryCodeValue = target.countryCode.value
  return countryCodes.find(x => x.code === countryCodeValue)
}

export default AnalyzeVoiceForm
export type { Props as AnalyzeVoiceFormProps }
